import React, { useState } from 'react';
import HighSchoolClassSelectionModal from './HighSchoolClassSelectionModal';

export const EditHighSchoolClassesButton = (props) => {
  const [showModal, setShowModal] = useState(false);

  const buttonStyle = {
    backgroundColor: props.chosenTenant.primary,
    color: 'white',
    fontSize: '17px',
    borderRadius: '40px',
    borderWidth: '0px',
    padding: '7px 23px 7px 23px',
    cursor: 'pointer',
    fontWeight: 'bold',
  };

  const toggleModal = () => {
    setShowModal(!showModal);
  };

  return (
    <>
      <button
        className="edit-high-school-classes-button"
        style={buttonStyle}
        tabIndex={0}
        onClick={toggleModal}
        onKeyDown={(e) => {
          if (['Enter'].includes(e.key)) toggleModal();
        }}
        type="button"
      >
        Edit High School Classes
      </button>
      {showModal && (
        <HighSchoolClassSelectionModal
          chosenTenant={props.chosenTenant}
          acadPlan={props.acadPlan}
          closeModal={toggleModal}
        />
      )}
    </>
  );
};
